import Bold from '@tiptap/extension-bold';
import { menuControlFor } from './_get_menu_control';

const syncMenu = ({ editor }) => {
  const control = menuControlFor(editor, 'text:formatting', 'bold');
  const controlIsActive = editor.isActive('bold');

  control?.classList?.toggle('active', controlIsActive);
};

export default [
  Bold.extend({
    onSelectionUpdate: syncMenu,
    onTransaction: syncMenu,
  }),
];
